import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';
import HelpPanel from './HelpPanel';
import HelpRegister from './pages/HelpRegister';
import HelpPersonalProfile from './pages/HelpPersonalProfile';

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    heading: {
        fontSize: '2.4rem',
        fontWeight: 700,
        color: '#26344a',
        marginBottom: '2rem',
        textAlign: 'center',
    },
    accordionContainer: {
        marginBottom: theme.spacing(3),
    },
}));

const HelpPersonal = () => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Typography variant="h2" className={classes.heading}>
                求職者用アカウント
            </Typography>

            <Box className={classes.accordionContainer}>
                <HelpPanel title="アカウント登録">
                    <HelpRegister />
                </HelpPanel>
            </Box>

            <Box className={classes.accordionContainer}>
                <HelpPanel title="プロフィール編集">
                    <HelpPersonalProfile />
                </HelpPanel>
            </Box>
        </Box>
    )
}

export default HelpPersonal
